(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoy-product-main"]) return;
  try {
    
  if (!customElements.get('hoy-variant-picker')) {
    class HoyVariantPicker extends HTMLElement {
      connectedCallback() {
        this.selects = Array.from(this.querySelectorAll('.hoy-variant-picker__select'));
        this.idInput = document.getElementById(this.dataset.idInputId);
        this.buyButton = document.getElementById(this.dataset.buyButtonId);

        const variantsScript = this.querySelector('[data-hoy-variants]');
        this.variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

        this.selects.forEach((select) => {
          select.addEventListener('change', this.updateVariant.bind(this));
        });
      }

      updateVariant() {
        const selectedValues = this.selects.map((select) => select.value);
        const match = this.variants.find((variant) =>
          selectedValues.every((value, index) => variant.options[index] === value)
        );

        if (!match || !this.idInput) return;

        this.idInput.value = match.id;

        if (this.buyButton) {
          this.buyButton.disabled = !match.available;
          const label = this.buyButton.querySelector('span');
          if (label) label.textContent = match.available ? 'Kjøp og last ned' : 'Utsolgt';
        }
      }
    }

    customElements.define('hoy-variant-picker', HoyVariantPicker);
  }

  if (!customElements.get('hoy-product-gallery')) {
    class HoyProductGallery extends HTMLElement {
      connectedCallback() {
        this.thumbs = Array.from(this.querySelectorAll('.hoy-product-gallery__thumb'));
        this.panels = Array.from(this.querySelectorAll('.hoy-product-gallery__panel'));

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.show(thumb.dataset.mediaId));
        });
      }

      show(mediaId) {
        this.panels.forEach((panel) => {
          const active = panel.dataset.mediaId === mediaId;
          panel.classList.toggle('hoy-product-gallery__panel--active', active);

          if (!active) {
            const video = panel.querySelector('video');
            if (video) video.pause();

            const iframe = panel.querySelector('iframe');
            if (iframe) iframe.src = iframe.src;
          }
        });

        this.thumbs.forEach((thumb) => {
          thumb.classList.toggle('hoy-product-gallery__thumb--active', thumb.dataset.mediaId === mediaId);
        });
      }
    }

    customElements.define('hoy-product-gallery', HoyProductGallery);
  }

  if (!customElements.get('hoy-sticky-buy-bar')) {
    class HoyStickyBuyBar extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.hoy-sticky-buy-bar__button');
        this.trigger = document.getElementById(this.dataset.triggerId);
        this.cartEl = document.querySelector('cart-notification, cart-drawer');
        this.buttonOutOfView = false;
        this.cartOpen = false;

        if (this.button) {
          this.button.addEventListener('click', () => {
            if (this.trigger && !this.trigger.disabled) this.trigger.click();
          });
        }

        if (this.trigger) {
          this.intersectionObserver = new IntersectionObserver((entries) => {
            this.buttonOutOfView = !entries[0].isIntersecting;
            this.update();
          });
          this.intersectionObserver.observe(this.trigger);
        }

        if (this.cartEl) {
          this.cartMutationObserver = new MutationObserver(() => {
            this.cartOpen = this.cartEl.classList.contains('active');
            this.update();
          });
          this.cartMutationObserver.observe(this.cartEl, { attributes: true, attributeFilter: ['class'] });
        }
      }

      update() {
        this.classList.toggle('hoy-sticky-buy-bar--visible', this.buttonOutOfView && !this.cartOpen);
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.cartMutationObserver?.disconnect();
      }
    }

    customElements.define('hoy-sticky-buy-bar', HoyStickyBuyBar);
  }

  } catch(e) { console.error(e); }
})();
})();
